import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Firstpage from "./pages/Firstpage";
import Linktree from "./pages/Linktree";
import Header from "./components/Header";
import ScrollEffects from "./components/ScrollEffects";
import { ThemeProvider } from "./ThemeContext";

// Lazy: keeps the calendar library (and its CSS) out of the home-page bundle
const CalendarDemo = lazy(() => import("./pages/CalendarDemo"));

function App() {
  return (
    <ThemeProvider>
      <ScrollEffects />
      <Header />
      <Routes>
        <Route path="/" element={<Firstpage />} />
        <Route path="/linktree" element={<Linktree />} />
        <Route
          path="/calendar-demo"
          element={
            <Suspense fallback={null}>
              <CalendarDemo />
            </Suspense>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
